import { API_BASE_URL } from "../../../constants";


export function shouldShowServicesTab(token: String) {
    return fetch(`${API_BASE_URL}/should_show_services_tab?token=${token}`);
}

export function getServices(token: String) {
    return fetch(`${API_BASE_URL}/services?token=${token}`);
}